<template>
    <div class="w-full h-auto mb-32 relative">
        <div class="sticky top-0" style="background-image: url(https://genesis.zeus.vision/assets/valentina/img/header1.jpg); background-repeat: no-repeat; background-size: cover; background-position: center; height:33vh; z-index:-1"></div>
        <All model="sales" :query="query" :immediate="true" v-slot="{data,loading}">
            <div v-if="!loading" class="h-auto">
                <div class="h-auto w-11/12 rounded-lg shadow-3xl mx-auto z-40 -mt-24 bg-white flex flex-col relative">
                    <div class="h-auto flex flex-col mb-2">
                        <div class="h-auto w-full flex flex-row justify-center items-end pt-4">
                            <span v-if="swiperIndexActive == 0" class="text-gray-500 font-semibold text-3xl">Ventas totales</span>
                            <span v-if="swiperIndexActive == 1" class="text-gray-500 font-semibold text-3xl">Empleados</span>
                        </div>

                        <div class="w-full h-auto flex flex-row justify-center items-center">
                            <span v-if="data.data.sales.sales.length > 0" class="text-3xl font-bold text-gray-700">{{data.data.sales.total | reduceBigNumbers() }}</span>
                            <span v-else class="text-3xl font-bold text-gray-700">0</span>
                            <span class="text-xl text-gray-700">€</span>
                        </div>
                        <div class="w-full h-auto flex flex-row justify-center items-center border-b border-gray-300 pb-2 mb-4">
                            <span class="text-lg text-gray-600 w-1/3 text-center" :class="{'text-green-400': data.data.sales.goal_diff >= 0, 'text-red-400': data.data.sales.goal_diff < 0}">{{data.data.sales.goal_diff | reduceBigNumbers() }}€</span>
                        </div>

                        <filters></filters>

                        <swiper :ref="swiperRef" class="w-full" :options="swiper_options" @slideChangeTransitionStart="showIndex()">
                            <swiper-slide>
                                <div v-if="data.data.sales.sales.length > 0" class="flex-1 h-full overflow-y-auto">
                                    <sale v-for="sale in data.data.sales.sales" :data="sale" :key="sale.id"></sale>
                                </div>
                            </swiper-slide>

                            <swiper-slide>
                                <div v-if="data.data.employees.sales.length > 0" class="flex-1 h-full overflow-y-auto">
                                    <employee v-for="employee in data.data.employees.sales" :data="employee" :key="employee.id"></employee>
                                </div>
                                <div v-else class="flex justify-center items-center text-gray-400 pt-12 pb-12">No hay datos de empleados</div>
                            </swiper-slide>

                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>
                    </div>
                </div>

                <div class="w-full h-56 pt-10 -mt-2 flex flex-col bg-white z-20 relative overflow-hidden">
                    <div class="h-10 flex flex-row justify-start items-center px-2">
                        <div class="h-8 w-8 mr-2 rounded-full shadow-md bg-blue-500 flex flex-row justify-center items-center active:bg-blue-400 active:shadow-inner" @click="changeModeGrap()">
                            <i class="mdi mdi-chart-areaspline text-white"></i>
                        </div>

                        <div class="h-full flex-1 flex flex-col justify-center items-start">
                            <span v-if="period != 'custom'" class="text-gray-700 mr-2">{{periodo}} vs {{periodo_ant}}</span>
                            <span v-else class="text-gray-700 mr-2">{{periodo}}</span>
                            <span class="text-xs text-gray-500">({{graphtype}} - Ventas totales)</span>
                        </div>
                    </div>

                    <div class="flex-1">
                        <chartarea chartId="asd" :data="data.data.sales.graph"></chartarea>
                    </div>
                </div>
            </div>
        </All>
    </div>
</template>

<script>
import filters from './filters.vue';
import sale from './sale.vue';
import employee from './employee';
import chartarea from './chartarea.vue';
import { state,actions } from '../store/store.js';
import { All } from '@/api/components';
var moment = require('moment');

export default {
    components:{
        filters,
        sale,
        employee,
        chartarea,
        All
    },
    data(){
        return{
            ventastotales: true,
            dates: null,
            swiperIndexActive: 0,
            modeGraph: false
        }
    },
    methods:{
        showIndex(){            
            this.swiperIndexActive = this.swiperindex.activeIndex;
        },
        changeModeGrap(){
            
            if(state.graph_type == 'accumulated'){
                actions.setGraphType('breakdown')
            } else {
                actions.setGraphType('accumulated')
            }

        }
    },
    computed:{
        periodo(){

            switch (this.period) {
                case 'today':
                    return 'Hoy'
                    break;

                case 'yesterday':
                    return 'Ayer'
                    break;

                case 'week':
                    return 'Semana'
                    break;

                case 'month':
                    return 'Mes'
                    break;

                case 'year':
                    return 'Año'
                    break;

                case 'custom':
                    return moment(state.dates.start).format('DD/MM/YY') + ' - ' + moment(state.dates.end).format('DD/MM/YY')
                    break;
            }

        },

        periodo_ant(){
            switch (this.period) {
                case 'today':
                    return '- 7 días'
                    break;
                case 'yesterday':
                    return '- 7 días'
                    break;
                case 'week':
                    return 'Semana anterior'
                    break;
                case 'month':
                    return 'Mes anterior'
                    break;
                case 'year':
                    return 'Año anterior'
                    break;
                case 'custom':
                    return this.dates
                    break;
            }
        },

        swiperindex(){
            return this.$refs[this.swiperRef].swiper
        },

        swiperRef() {
            return 'swiper-'+this.period+(state.store ?? 0);
        },

        period(){
            return state.period
        },

        query(){
            if(state.period != 'custom' && !state.dates){
                return {
                    period: state.period,
                    store: state.store,
                    graph_type: state.graph_type
                }

            } else {
                if(state.dates == null){
                    return{
                        period: state.period,
                        store: state.store,
                        graph_type: state.graph_type
                    }

                } else {
                    return{
                        period: state.period,
                        store: state.store,
                        from: state.dates.start,
                        to: state.dates.end,
                        graph_type: state.graph_type
                    }

                }

            }
        },

        graphtype(){

            if(state.graph_type == 'accumulated'){
                return 'Acumulado'
            } else {
                return 'Desglosado'
            }
            

        },

        swiper_options() {
            return {
                initialSlide: this.swiperIndexActive,
                direction: 'horizontal',
                slidesPerView: 1,
                spaceBetween: 1,
                slidesPerGroup:1,
                pagination:{
                    el: '.swiper-pagination'
                },
                autoHeight: true
            };
        }
    },
    mounted(){
        
    }
}
</script>

<style lang="css">

    .el-input__icon,
    .el-input__icon,
    .el-range__close-icon{
        display: none;
    }

    .el-range-input{
        width: 45% !important;
    }

    .el-date-editor .el-range-editor .el-input__inner .el-date-editor--daterange .is-active{
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .swiper-pagination{
        bottom: 0px !important;
        /* margin-bottom: -.5rem !important; */
    }

</style>